// pages/tenantBilling/billingFormat.js
// Formatting and arithmetic shared by the billing screens (BillingParts,
// TenantPaymentTab, TenantPlan). The server recomputes every figure; these
// only draw what it will store.

const inrFormatter = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 2 });
export const inr = (n) => inrFormatter.format(Number.isFinite(Number(n)) ? Number(n) : 0);

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
/** '2026-11-04' → '4 Nov 2026' — a calendar day, never shifted by the browser's time zone. */
export const day = (d) => {
    if (!d) return '—';
    const [y, m, dd] = String(d).slice(0, 10).split('-').map(Number);
    if (!y || !m || !dd) return '—';
    return `${dd} ${MONTHS[m - 1]} ${y}`;
};

/** Client-side mirror of the server's plan end: the day before the same date next month / year. */
export function planEndFor(start, period) {
    const [y, m, d] = String(start).slice(0, 10).split('-').map(Number);
    const idx = m - 1 + (period === 'yearly' ? 12 : 1);
    const ty = y + Math.floor(idx / 12);
    const tm = idx % 12;
    const lastDay = new Date(Date.UTC(ty, tm + 1, 0)).getUTCDate();
    const next = Date.UTC(ty, tm, Math.min(d, lastDay));
    return new Date(next - 86400000).toISOString().slice(0, 10);
}

/** Today in India — the tenant form's default time zone; the server decides the real one. */
export const todayIso = () => new Intl.DateTimeFormat('en-CA', {
    timeZone: 'Asia/Kolkata', year: 'numeric', month: '2-digit', day: '2-digit',
}).format(new Date());

/** The arithmetic of the plan, as the server does it (it recomputes anyway). */
export function planTotals(lines, discount) {
    const featuresTotal = Math.round(lines.reduce((s, l) => s + (Number(l.price) || 0), 0) * 100) / 100;
    const v = Math.max(0, Number(discount?.value) || 0);
    let discountAmount = 0;
    if (discount?.type === 'percentage') discountAmount = (featuresTotal * Math.min(v, 100)) / 100;
    else if (discount?.type === 'amount') discountAmount = Math.min(v, featuresTotal);
    discountAmount = Math.round(discountAmount * 100) / 100;
    return { featuresTotal, discountAmount, total: Math.round((featuresTotal - discountAmount) * 100) / 100 };
}
